<div class="log-detail-dialog">
  <div class="dialog-header">
    <h2>Log Details</h2>
    <button mat-icon-button (click)="close()" class="close-button" tabindex="-1">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content cdkFocusInitial>
    <div class="log-metadata">
      <div class="metadata-row">
        <div class="metadata-item">
          <span class="label">Level</span>
          <span class="level-badge" [ngClass]="getLevelClass(data.log.level)">
            {{ data.log.level }}
          </span>
        </div>
        <div class="metadata-item">
          <span class="label">Timestamp</span>
          <span class="value timestamp-value">{{ formatTimestamp(data.log.timeStamp) }}</span>
        </div>
      </div>
      @if (data.log.requestPath) {
      <div class="metadata-row">
        <div class="metadata-item full-width">
          <span class="label">Request Path</span>
          <span class="request-path-badge">{{ data.log.requestPath }}</span>
        </div>
      </div>
      }
      @if (data.log.userId || data.log.employeeId) {
      <div class="metadata-row">
        @if (data.log.userId) {
        <div class="metadata-item half-width">
          <span class="label">User ID</span>
          <span class="value">{{ data.log.userId }}</span>
        </div>
        }
        @if (data.log.employeeId) {
        <div class="metadata-item half-width">
          <span class="label">Employee ID</span>
          <span class="value">{{ data.log.employeeId }}</span>
        </div>
        }
        @if (data.log.employee) {
        <div class="metadata-item">
          <span class="label">Employee</span>
          <span class="value">{{ data.log.employee.displayName }}</span>
        </div>
        }
      </div>
      }
      <div class="metadata-row message-row" (click)="copyMessage()">
        <div class="metadata-item full-width">
          <div class="label-row">
            <span class="label">Message</span>
            <mat-icon class="copy-icon" [class.success]="isCopySuccess">
              {{ isCopySuccess ? 'check' : 'content_copy' }}
            </mat-icon>
          </div>
          <pre class="value message-value">{{ data.log.message }}</pre>
        </div>
      </div>
      @if (data.log.exception) {
      <div class="metadata-row exception-row" (click)="copyException()">
        <div class="metadata-item full-width">
          <div class="label-row">
            <span class="label">Exception</span>
            <mat-icon class="copy-icon" [class.success]="isExceptionCopySuccess">
              {{ isExceptionCopySuccess ? 'check' : 'content_copy' }}
            </mat-icon>
          </div>
          <pre class="value exception-value">{{ data.log.exception }}</pre>
        </div>
      </div>
      }
    </div>
  </mat-dialog-content>
</div>
